import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
// import { Controller } from "react-hook-form";
// import Select from "components/Select/Select";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import LoadingButton from "@mui/lab/LoadingButton";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import "react-quill/dist/quill.snow.css";
// import PictureUpload from "components/CustomUpload/PictureUpload.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { puushdotPoolService } from "services/puushdotPoolService";
// import { userService } from "services/userService";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
// import { Box } from "@material-ui/core";
import CardFooter from "../../components/Card/CardFooter";
import Button from "../../components/CustomButtons/Button";

const useStyles = makeStyles(styles);

export default function PuushdotPoolCreate() {
  const {
    register: puushdot,
    handleSubmit,
    setValue,
    // control,
  } = useForm({
    status: false,
  });
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const { id } = useParams();

  async function createPuushdotPool(payload) {
    setLoading(true);
    try {
      const { data } = await puushdotPoolService.create(payload);
      toast.success("Created pup404 pool");
      window.setTimeout(
        () => history.push("/admin/pup404/view/" + data._id),
        2000
      );
    } catch (e) {
      toast.error(e.response.data.message[0]);
    } finally {
      setLoading(false);
    }
  }

  async function updatePuushdotPool(payload) {
    setLoading(true);
    if (!payload.password) {
      delete payload.password;
    }
    try {
      const { data } = await puushdotPoolService.update(id, payload);
      toast.success("Updated pup404 pool");
      window.setTimeout(
        () => history.push("/admin/pup404/view/" + data._id),
        2000
      );
    } catch (e) {
      console.log(e);
      toast.error(e?.response?.data?.message[0]);
    } finally {
      setLoading(false);
    }
  }

  async function onSubmit(form) {
    const payload = {
      name: form.name,
      address: form.address,
      collectionId: form.collectionId,
      ownerAddress: form.ownerAddress,
      puushFeeReceiver: form.puushFeeReceiver,
      puushFeeAmount: form.puushFeeAmount,
      chainId: form.chainId,
    };
    console.log({ payload });
    if (id) {
      updatePuushdotPool(payload);
    } else {
      createPuushdotPool(payload);
    }
  }

  async function fetchPuushdotPool(id) {
    const { data } = await puushdotPoolService.view(id);
    const fields = [
      "name",
      "address",
      "ownerAddress",
      "collectionId",
      "puushFeeReceiver",
      "puushFeeAmount",
      "chainId",
    ];
    fields.forEach((field) => setValue(field, data[field]));
    // setValue("new_name", data.name);
  }

  React.useEffect(() => {
    if (id) fetchPuushdotPool(id);
  }, [id]);

  const classes = useStyles();
  return (
    <Card>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CardHeader color="rose" icon>
          <CardIcon color="rose">
            <Contacts />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            {id ? "Edit pup404 pool" : "Create pup404 pool"}
          </h4>
        </CardHeader>
        <GridContainer>
          <GridItem xs={12} sm={12} md={9}>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Name
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "text",
                      autoComplete: "off",
                      ...puushdot("name"),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Address
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "text",
                      autoComplete: "off",
                      ...puushdot("address"),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer alignItems="flex-start">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Owner Address
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "text",
                      ...puushdot("ownerAddress"),
                    }}
                  />
                </GridItem>
              </GridContainer>

              {/* <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Role
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <Controller
                    control={control}
                    name="role"
                    render={({ field: { value, onChange } }) => (
                      <Select
                        name="role"
                        label="Role"
                        onChange={onChange}
                        value={value ?? "user"}
                        options={[
                          { value: "admin", label: "ADMIN" },
                          { value: "user", label: "USER" },
                        ]}
                      />
                    )}
                  />
                </GridItem>
              </GridContainer> */}

              <GridContainer alignItems="flex-start">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Collection ID
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "text",
                      ...puushdot("collectionId"),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer alignItems="flex-start">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Puush Fee Receiver
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "text",
                      ...puushdot("puushFeeReceiver"),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer alignItems="flex-start">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Puush Fee Amount
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "text",
                      ...puushdot("puushFeeAmount"),
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <GridContainer justify="flex-end">
                <GridItem xs={12} sm={6} md={6}>
                  <Button onClick={() => history.goBack()}>Cancel</Button>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <LoadingButton
                    type="submit"
                    loading={loading}
                    variant="outlined"
                  >
                    Submit
                  </LoadingButton>
                </GridItem>
              </GridContainer>
            </CardFooter>
          </GridItem>

          {/* <GridItem xs={12} sm={12} md={3}>
            <Box sx={{ justifyContent: "center" }}>
              …
              <Controller
                control={control}
                name="avatar"
                render={({ field: { value, onChange } }) => (
                  <PictureUpload value={value} onChange={onChange} />
                )}
              />
            </Box>
            <Box sx={{ justifyContent: "center" }}>
              …
              <Controller
                control={control}
                name="cover"
                render={({ field: { value, onChange } }) => (
                  <PictureUpload value={value} onChange={onChange} />
                )}
              />
            </Box>
          </GridItem> */}
        </GridContainer>
      </form>
    </Card>
  );
}
